import { AUTH_API, handleApiError } from '../../utils/axios';

export const createVehicle = async (vehicle) => {
  try {
    const { data } = await AUTH_API.post(`/api/v1/vehicles`, vehicle);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateVehicle = async (vin, vehicle) => {
  try {
    const { data } = await AUTH_API.put(`/api/v1/vehicles/${vin}`, vehicle);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getVehicle = async (vin) => {
  try {
    const { data } = await AUTH_API.get(`/api/v1/vehicles/${vin}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
